import request from "@/core/data/network/client/request";
import Api from "@/core/data/network/constants/api_routes";

export default {
  getCustomerComplaints: async (pagination, term) => {
    return request.get(Api.getCustomerComplaints(pagination, term));
  }
};